import type { BoardType, Color } from "./baseTypes";
import { isBacklogBoard } from "./board";

export type Functionality = "workitem" | "note" | "risk" | "dependency";

export interface Priority {
  value: number;
  text: string;
}

export interface StickyType {
  id: string;
  name: string;
  almType: string | null;
  color: Color;
  altColor: Color; // 'Taken' color (for backlog items assigned to a team, or solution backlog items assigned to an art)
  priorities?: Record<number, Priority>;
  functionality: Functionality;
  origin: BoardType; // the board type where the card was initially created
  flexOrigin: string | null; // the flex-board/colaboration-canvas where the card was initially created
  usable: readonly BoardType[]; // where the sticky note can be mirrored too
  flexUsable: readonly string[];
}

export function isDependency(card: { type: StickyType }) {
  return card.type.functionality === "dependency";
}

export function isWorkitem(card: { type: StickyType }) {
  return card.type.functionality === "workitem";
}

export function isNote(card: { type: StickyType }) {
  return card.type.functionality === "note";
}

export function isRisk(card: { type: StickyType }) {
  return card.type.functionality === "risk";
}

export function isArtLevelWorkitem(card: { type: StickyType }) {
  return isWorkitem(card) && card.type.origin === "backlog";
}

/** ART-level or solution-level backlog workitem. */
export function isBacklogWorkitem(card: { type: StickyType }) {
  return isWorkitem(card) && isBacklogBoard(card.type.origin);
}

export function isTeamLevelWorkitem(card: { type: StickyType }) {
  return isWorkitem(card) && card.type.origin === "team";
}

export interface AlmStickyType {
  id: string;
  isMapped: boolean;
}
